import React, { useEffect, useState } from 'react'

import {
  IonBadge,
  IonButton,
  IonCard,
  IonCardContent, IonProgressBar, IonText
} from '@ionic/react'
import { useConfig } from '../data/store/useConfig'
import { useProfile } from '../data/store/useProfile'
import { ArtistId } from '../models/Artist'
import { LoginService } from '../services/LoginService'
import AsyncArtistButton from './AsyncArtistButton'
import PleaseLoginCard from './PleaseLoginCard'
import { APP_TITLE, ENABLE_GROUPS } from '../config/env'

const defaultMessage =
  `You haven't joined any active groups yet. To join a group, find the invitation link & passcode to your group (this was sent out in an email from ${APP_TITLE} and also is listed on your course information page).`

const RequestAccessCard: React.FC<{
  authorId?: ArtistId
  message?: string
  // SON-26: 1 when this card is a page's main content (the empty-state
  // dashboard), 2 when embedded under another page heading, so we never
  // emit two <h1>s on the same view.
  headingLevel?: 1 | 2
}> = ({ message, headingLevel = 1 }) => {
  const Heading = (`h${headingLevel}` as 'h1' | 'h2')
  const { authenticated } = useProfile()
  const loginStatus = useProfile((x) => x.status)
  const id = useProfile((x) => x.authorId)
  const ownerId = useProfile((x) => x.ownerId)
  const membership = useConfig((x) => x.activeGroups())
  const inactiveGroups = useConfig((x) => x.inactiveGroups())

  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 3000)
  }, [])

  // Don't show access card when groups are disabled
  if (!ENABLE_GROUPS) {
    return null
  }

  if (loginStatus !== 'unknown' && !authenticated) {
    return (
      <IonCard className='ion-text-center'>
        <IonCardContent>

          <IonButton onClick={LoginService.login}>
            Login
          </IonButton>
        </IonCardContent>
      </IonCard>
    )
  }
  if(typeof id==='undefined'){
    return <PleaseLoginCard action={'Continue'}/>
  }
  return (
    <IonCard>
      <IonCardContent>
        {/* SON-26: heading for the empty-state dashboard. Defaults to <h1>
            (this card owns the page) but drops to <h2> when embedded. */}
        <Heading className="request-access-title">Your Groups</Heading>
        {loading ? (
          <>
            Loading <IonProgressBar type="indeterminate" />
          </>
        ) : (
          <>
            {id && <AsyncArtistButton id={id} />}
            <IonBadge color="success">
              {membership.length} active groups
            </IonBadge>{' '}
            <IonBadge color="warning">
              {inactiveGroups.length} inactive groups
            </IonBadge>{' '}
            <IonCardContent>
              <IonText color="dark">
                {membership.length === 0 && defaultMessage}
              </IonText>
            </IonCardContent>
          </>
        )}
      </IonCardContent>
    </IonCard>
  )
}

export default RequestAccessCard
